module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password-form p-lg-5 p-md-4 p-3"
  }, [_c('h1', [_vm._v("Vytvořit nový přístup - obnova zapomenutého hesla")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showForm) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.noOp()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "inputUsername"
    }
  }, [_c('nobr', [_vm._v("Vím klientské číslo")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputUsername),
      expression: "inputUsername"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric|min:7'),
      expression: "'numeric|min:7'"
    }],
    ref: "username",
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('username')
    },
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "1012233",
      "disabled": _vm.submitPending,
      "maxlength": "10",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.inputUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputUsername = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Vložte prosím 7místné klientské číslo")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n        Klientské číslo je sedmimístné, např. 1012233.\n        Odpovídá variabilnímu symbolu, který používáte pro platby trvalým příkazem za služby\n        společnosti Rychlý drát, s.r.o. Na výpisu z Vaší banky jej najdete\n        u odchozích plateb ve prospěch účtu 344355366/2010.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitPending || _vm.errors.has('username') || _vm.inputUsername == ''
    },
    on: {
      "click": _vm.submitUsername
    }
  }, [(_vm.submitPending != 1) ? _c('span', [_vm._v("Pokračovat")]) : _vm._e(), _vm._v(" "), (_vm.submitPending == 1) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showForm) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.noOp()
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_c('nobr', [_vm._v("Vím e-mail")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputEmail),
      expression: "inputEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "jmeno@example.com",
      "disabled": _vm.submitPending
    },
    domProps: {
      "value": (_vm.inputEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Vložte prosím platnou e-mail adresu")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n        Zadejte e-mail adresu, kterou jste vyplnili do smlouvy o poskytnutí telekomunikačních služeb\n        se společností Rychlý drát, s.r.o.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitPending || _vm.errors.has('email') || _vm.inputEmail == ''
    },
    on: {
      "click": _vm.submitEmail
    }
  }, [(_vm.submitPending != 2) ? _c('span', [_vm._v("Pokračovat")]) : _vm._e(), _vm._v(" "), (_vm.submitPending == 2) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-10 error-box"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.displayError) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.showStep2a) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_vm._v("\n       Na adresu " + _vm._s(this.displayEmails) + " jsme odeslali e-mail s instrukcemi pro nastavení nového hesla.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10 blue-box"
  }, [_vm._v("\n      Klikněte na odkaz, který najdete v e-mailu.\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-606ea0b6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
// module id = 324
// module chunks = 1 2